import React from 'react';

/**
 * Unified premium loader — cream/gold museum theme.
 * variant: fullscreen | overlay | inline | minimal
 */
export default function PremiumLoader({
  message = 'One moment…',
  subtitle = '',
  variant = 'fullscreen',
  className = '',
}) {
  const spinner = <div className="art-premium-loader-spinner mx-auto" role="status" aria-hidden />;

  const textBlock = (
    <>
      {message ? <p className="art-premium-loader-message">{message}</p> : null}
      {subtitle ? <p className="art-premium-loader-sub">{subtitle}</p> : null}
    </>
  );

  if (variant === 'minimal') {
    return (
      <div className={`art-premium-loader-inline ${className}`.trim()} aria-live="polite" aria-busy="true">
        {spinner}
        {message ? <p className="art-premium-loader-message text-sm">{message}</p> : null}
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`art-premium-loader-inline ${className}`.trim()} aria-live="polite" aria-busy="true">
        <div className="art-premium-loader-card w-full max-w-xs">
          {spinner}
          {textBlock}
        </div>
      </div>
    );
  }

  const card = (
    <div className="art-premium-loader-card">
      {spinner}
      {textBlock}
    </div>
  );

  if (variant === 'overlay') {
    return (
      <div className={`art-premium-loader-overlay ${className}`.trim()} aria-live="polite" aria-busy="true">
        {card}
      </div>
    );
  }

  return (
    <div className={`art-premium-loader-page ${className}`.trim()} aria-live="polite" aria-busy="true">
      {card}
    </div>
  );
}
